import { DeleteAdjusterOtherDamagedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteAdjusterOtherDamagedImages/deleteAdjusterOtherDamagedImagesQuery.type';
import { deleteAdjusterOtherDamagedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteAdjusterOtherDamagedImages/deleteAdjusterOtherDamagedImagesQueryFunction';

export const deleteAdjusterOtherDamagedImagesQueryOptions = () => {
  return {
    mutationKey: ['deleteAdjusterOtherDamagedImages'],
    mutationFn: (params: DeleteAdjusterOtherDamagedImagesQueryParamsType) =>
      deleteAdjusterOtherDamagedImagesFunction({ ...params }),
  };
};
